import React from 'react';
import { Home } from './pages/Home';
import { RequestQuote } from './pages/RequestQuote';
import { ServiceContentPage, contentBreadcrumbs } from './pages/ServiceContentPage';
import { UtilityContentPage } from './pages/UtilityContentPage';
import { NotFound } from './pages/NotFound';
import { PageHead } from './components/pages/PageHead';
import { resolvePage } from './utils/routes';
import type { PageMetadata } from './types/pageContent';
export function App() {
  const route = typeof window === 'undefined' ? {
    kind: 'home' as const,
    path: '/'
  } : resolvePage(window.location.pathname, window.location.search);
  let content: React.ReactNode, metadata: PageMetadata;
  if (route.kind === 'home') {
    content = <Home data-id="element-0" data-mp="2wiyvwox99na3" />;
    metadata = {
      title: 'Commercial Truck Collision Repair in Brighton MI | Motor City Truck Collision',
      description: 'Collision repair, bodywork and commercial painting for semis, box trucks, fleets and trailers in Brighton, Michigan. Call 248-986-8000 or request a quote.',
      path: '/',
      kind: 'home'
    };
  } else if (route.kind === 'quote') {
    content = <RequestQuote data-id="element-1" data-mp="3mlavz2zp87rv" />;
    metadata = {
      title: 'Request a Quote | Motor City Truck Collision',
      description: 'Tell the Brighton shop about your vehicle or equipment and the bodywork or painting needed. Photos are optional. This form is a client preview.',
      path: route.path,
      kind: 'quote',
      breadcrumbs: [{
        label: 'Home',
        path: '/'
      }, {
        label: 'Request a Quote',
        path: route.path
      }]
    };
  } else if (route.kind === 'content') {
    const page = route.page;
    content = ['service', 'guide', 'about'].includes(page.kind) ? <ServiceContentPage page={page} data-id="element-2" data-mp="38l8hlqqlnwhd" /> : <UtilityContentPage page={page} data-id="element-3" data-mp="38k6v8q44vnkc" />;
    metadata = {
      title: page.title,
      description: page.description,
      path: page.path,
      kind: page.kind,
      image: page.image,
      breadcrumbs: contentBreadcrumbs(page)
    };
  } else {
    content = <NotFound data-id="element-4" data-mp="nxn53r85d1mu" />;
    metadata = {
      title: 'Page Not Found | Motor City Truck Collision',
      description: 'Find Motor City Truck Collision services, contact information and quote requests from the homepage.',
      kind: 'not-found'
    };
  }
  return <><PageHead metadata={metadata} data-id="element-5" data-mp="3udaw269tuj3n" />{content}</>;
}